// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__pso0d","cell":"ColumnAccessor_cell__481t_","firstCellAccent":"ColumnAccessor_firstCellAccent__1YcPP"};